/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubscribeToIncidentRequest} from '@cash-web/protos/squareup/cash/incidentalerts/app/v1/app.pb'
import {SubscribeToIncidentResponse} from '@cash-web/protos/squareup/cash/incidentalerts/app/v1/app.pb'


export const subscribeToIncident = (request: SubscribeToIncidentRequest, options?: CashRequestOptions) => post<SubscribeToIncidentRequest, SubscribeToIncidentResponse>("/2.0/cash/subscribe-to-incident", request, {...options, rejectOnError: true })